import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueMeta from 'vue-meta';
import VueCookies from 'vue-cookies';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import Toastr from 'vue-toastr';
import VueMoment from 'vue-moment';
import Timezone from 'moment-timezone';

import Draggable from 'vuedraggable';
import {hasCookieAccepted} from '@/utils/cookieConsent';
import {initializeSentry} from '@/utils/sentry';

import router from './routes/routes';
import store from './store';
import filters from './filters';
import i18n from './i18n';
import './common/styles/app.scss';

import App from './App';
import { clickOutside, focus } from './directives';
import EliisDropdown from '@components/Dropdown';
import EliisTooltip from '@components/ToolTip';
import EliisTablefilter from '@components/table/Filter';
import EliisTable from '@components/table/Table';
import EliisEditor from '@components/quill/QuillBasic';
import EliisLoader from '@components/loaders/ContentLoader';
import AddNewButton from '@components/buttons/AddNewButton';
import ConfirmButton from '@components/buttons/ConfirmButton';
import EmptyListMessage from '@components/notifs/EmptyListMessage';
import PageTitle from '@components/PageTitle';
import ProfileImage from '@components/ProfileImage';
import EModal from '@components/modals/BaseModal';
import ModalHeader from '@components/ModalHeader';
import HeaderIconPack from '@common/layout/headericons/HeaderIconPack';
import ListRowItem from '@components/ListRowItem';
import ButtonLoader from '@components/ButtonLoader';
import RoundIconButton from '@components/buttons/RoundIconButton.vue';
import DatePicker from '@components/datepicker/DatePicker.vue';
import CommentsList from '@components/comments/CommentsList.vue';
import CommentInput from '@components/comments/CommentInput.vue';
import CommentIcon from '@components/comments/CommentIcon.vue';

const moment = require('moment');
Vue.use(VueMoment, {moment, Timezone});
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(Toastr, {
    defaultTimeout: 8000,
    defaultPosition: 'toast-top-center',
    defaultCloseOnHover: false,
    defaultPreventDuplicates: true,
    defaultProgressBar: false
});
Vue.use(VueMeta);

const locale = Vue.prototype.$cookies.get('lang') || 'en';

i18n.locale = locale;

const requireComponent = require.context('./common/components/input', false, /.*\.(vue)$/);
requireComponent.keys().forEach((fileName) => {
    const Component = requireComponent(fileName).default;
    if (Component.name) {
        Vue.component(Component.name, Component);
    }
});

Vue.component('HeaderIconPack', HeaderIconPack);
Vue.component('EmptyListMessage', EmptyListMessage);
Vue.component('AddNewButton', AddNewButton);
Vue.component('ConfirmButton', ConfirmButton);
Vue.component('ELoader', EliisLoader);
Vue.component('EDropdown', EliisDropdown);
Vue.component('ETooltip', EliisTooltip);
Vue.component('ETable', EliisTable);
Vue.component('ETableFilter', EliisTablefilter);
Vue.component('EEditor', EliisEditor);
Vue.component('PageTitle', PageTitle);
Vue.component('ProfileImage', ProfileImage);
Vue.component('EModal', EModal);
Vue.component('ModalHeader', ModalHeader);
Vue.component('EListItem', ListRowItem);
Vue.component('EBtnLoader', ButtonLoader);
Vue.component('RoundIconButton', RoundIconButton);
Vue.component('EDatepicker', DatePicker);
Vue.component('CommentsList', CommentsList);
Vue.component('CommentInput', CommentInput);
Vue.component('CommentIcon', CommentIcon);
Vue.component('EDraggable', Draggable);

// eslint-disable-next-line no-undef
Vue.component('pagination', require('laravel-vue-pagination'));

// TODO: Vue3 - update directive registration
// const app = createApp(App);
// app.directive('click-outside', clickOutside);
// app.directive('focus', focus);
Vue.directive('click-outside', clickOutside);
Vue.directive('focus', focus);

if (hasCookieAccepted('statistics')) {
    initializeSentry(Vue);
}

// Vue 3: replace with compilerOptions.isCustomElement for these tags.
Vue.config.ignoredElements = ['media-i18n', 'video-player', 'video-skin'];

export const vm = new Vue({
    el: '#app',
    i18n,
    router,
    filters,
    store,
    render: h => h(App)
});
export const eventBus = new Vue();
